var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFmLogoCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 149,
    viewBox: "0 0 242 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1697 19.0251V1.79998H0.401367V96H18.2994V57.5126H53.1534V40.422H18.2994V19.0251H62.1697Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.231 0.992554C86.1822 0.992554 67.4768 21.9857 67.4768 49.0346C67.4768 76.0834 86.1822 97.0766 113.231 97.0766C140.28 97.0766 158.851 76.0834 158.851 49.0346C158.851 21.9857 140.28 0.992554 113.231 0.992554ZM113.231 79.044C96.006 79.044 85.7785 66.1251 85.7785 49.0346C85.7785 31.8094 96.006 18.8906 113.231 18.8906C130.322 18.8906 140.549 31.8094 140.549 49.0346C140.549 66.1251 130.322 79.044 113.231 79.044Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 96H240.167L219.981 61.0114C231.689 56.1668 237.879 45.4011 237.879 32.7514C237.879 15.5263 226.171 1.79998 205.178 1.79998H170.324V96H188.222V63.7028H201.275L219.981 96ZM188.222 19.0251H204.774C213.656 19.0251 219.308 24.6771 219.308 32.7514C219.308 40.8257 213.656 46.6123 204.774 46.6123H188.222V19.0251Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7288 122.297L14.614 135.295L6.57257 122.297H2.01946V148H6.90304V131.807L13.1819 141.941H16.0827L22.3616 131.807V148H27.2452V122.297H22.7288Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8764 148H53.421L44.021 122.297H39.0272L29.6273 148H35.1718L37.1546 142.198H45.8569L47.8764 148ZM38.8069 137.535L41.5241 129.641L44.2413 137.535H38.8069Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9346 122.297V138.967L60.5799 122.297H55.8065V148H60.6901V131.33L71.008 148H75.8182V122.297H70.9346Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4641 148H102.009L92.6086 122.297H87.6149L78.2149 148H83.7594L85.7422 142.198H94.4445L96.4641 148ZM87.3946 137.535L90.1118 129.641L92.8289 137.535H87.3946Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.106 134.12V138.049H120.761V140.913C119.475 142.492 117.529 143.373 115.033 143.373C110.333 143.373 107.542 139.848 107.542 135.185C107.542 130.485 110.333 126.96 115.033 126.96C117.86 126.96 119.99 128.245 121.238 130.302L125.681 128.098C123.551 124.427 119.769 122.077 115.033 122.077C107.652 122.077 102.548 127.805 102.548 135.185C102.548 142.566 107.652 148.294 115.033 148.294C119.769 148.294 123.551 145.98 125.681 142.309V134.12H115.106Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.414 143.337V137.498H145.246V132.835H134.414V126.997H146.384V122.297H129.531V148H146.605V143.337H134.414Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.787 122.297L162.672 135.295L154.63 122.297H150.077V148H154.961V131.807L161.24 141.941H164.141L170.419 131.807V148H175.303V122.297H170.787Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.221 143.337V137.498H195.053V132.835H184.221V126.997H196.191V122.297H179.337V148H196.412V143.337H184.221Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M215.012 122.297V138.967L204.658 122.297H199.884V148H204.768V131.33L215.086 148H219.896V122.297H215.012Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M241.717 122.297H223.027V126.997H229.93V148H234.814V126.997H241.717V122.297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmLogoCard);
export default __webpack_public_path__ + "static/media/FM_logo_card.a9ab4b59bdf9dd6ce263ed5de732d703.svg";
export { ForwardRef as ReactComponent };